import { Download } from 'lucide-react';
import { toast } from 'sonner';
import { Button } from '@/components/ui/button';
import { exportToCsv } from '@/lib/csv';

const CsvExportButton = ({ filename, columns, rows, label = 'Export CSV', size = 'sm' }) => (
  <Button
    type="button"
    variant="outline"
    size={size}
    disabled={!rows?.length}
    onClick={() => {
      if (exportToCsv(filename, columns, rows)) {
        toast.success(`Exported ${rows.length} rows`);
      }
    }}
  >
    <Download className="w-4 h-4 mr-2" />
    {label}
  </Button>
);

export default CsvExportButton;
